import { VolopFunctions } from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/volopFunctions';

export type State = VolopFunctions | null | undefined;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default function volopFunctions(state: State = null, action: Action) {
  switch (action.type) {
    case 'VOLOP_FUNCTIONS_SET': {
      return action.volopFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
